/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BidManagementShowOrderResponse } from './BidManagementShowOrderResponse';

export type BidManagementShowOrderResponseApiRespoonse = {
    data?: BidManagementShowOrderResponse;
    status?: BidManagementShowOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BidManagementShowOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

